export const aNamed2 = "a-named2";
